<template>
  <div class='statistics-admission'>
    <div class='ly-card hd'>
      <el-select class='m-r-10' v-model='searchFormData.year' placeholder='学年'>
        <el-option v-for='item in years' :key='item.value' :label='item.label' :value='item.value'></el-option>
      </el-select>
      <el-select class='m-r-10' v-model='searchFormData.term' placeholder='学期'>
        <el-option v-for='item in terms' :key='item.value' :label='item.label' :value='item.value'></el-option>
      </el-select>
      <el-select
        class='m-r-10'
        v-model='searchFormData.org_id'
        placeholder='部门'
        @change='getRootSp'
        @clear='search'
        filterable
        clearable
      >
        <el-option v-for='item in org_ids' :key='item.id' :label='item.name' :value='item.id'></el-option>
      </el-select>
      <el-select
        class='m-r-10'
        v-model='searchFormData.root_specialized_subject_id'
        placeholder='项目大类'
        :disabled='!searchFormData.org_id'
        @clear='search'
        @change='getSp'
        filterable
        clearable
      >
        <el-option v-for='item in root_specialized_subject_ids' :key='item.id' :label='item.name' :value='item.id'>
        </el-option>
      </el-select>
      <el-select
        class='m-r-10'
        @clear='search'
        @change='search'
        v-model='searchFormData.specialized_subject_id'
        placeholder='项目'
        filterable
        clearable
        :disabled='!searchFormData.org_id || !searchFormData.root_specialized_subject_id'
      >
        <el-option v-for='item in specialized_subject_ids' :key='item.id' :label='item.name' :value='item.id'>
        </el-option>
      </el-select>
      <el-date-picker
        v-model='date'
        class='m-r-10'
        type='daterange'
        range-separator='至'
        start-placeholder='开始日期'
        value-format='yyyy-MM-dd'
        :clearable='false'
        end-placeholder='结束日期'
        :picker-options='pickerOptions'
      >
      </el-date-picker>
      <el-input class='m-r-10' clearable style='width: 220px' v-model.trim='searchFormData.query' placeholder='班级名称/代码'></el-input>
      <!-- <el-button size="medium" @click="reset">重置</el-button> -->
      <el-button type='primary' @click='search'>查询</el-button>
      <el-button type='primary' @click='exportExcel'>导出</el-button>
    </div>
    <div class='ly-card'>
      <table
        class='native-table' v-loading='loading'>
        <tr style='font-weight: bold'>
          <td colspan='3'>总计</td>
          <td>{{ totalTableData.course_count }}</td>
          <td>{{ totalTableData.class_size }}</td>
          <td>{{ totalTableData.sign_up_count }}</td>
          <td>{{ totalTableData.pay_count }}</td>
          <td>{{ totalTableData.refund_count }}</td>
          <td>{{ totalTableData.reserved_count }}</td>
          <td>{{ totalTableData.edu_count }}</td>
          <td>{{ totalTableData.minister_count }}</td>
          <td>{{ totalTableData.group_count }}</td>
          <td>{{ totalTableData.website_count }}</td>
          <td>{{ totalTableData.total_fee }}</td>
        </tr>
        <tr>
          <th>名称</th>
          <th>学年</th>
          <th>学期</th>
          <th>课次</th>
          <th>预招人数</th>
          <th>报名人数</th>
          <th>缴费人数</th>
          <th>退费人数</th>
          <th>预留人数报名</th>
          <th>教务报名</th>
          <th>部长报名</th>
          <th>集体报名</th>
          <th>外网报名</th>
          <th>缴费金额</th>
        </tr>
        <tr v-for='(item,index) in getTableData' :key='`${item.name}/${index}`'>
          <td>{{ item.name }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.term_label }}</td>
          <td>{{ item.course_count }}</td>
          <td>{{ item.class_size }}</td>
          <td>{{ item.sign_up_count }}</td>
          <td>{{ item.pay_count }}</td>
          <td>{{ item.refund_count }}</td>
          <td>{{ item.reserved_count }}</td>
          <td>{{ item.edu_count }}</td>
          <td>{{ item.minister_count }}</td>
          <td>{{ item.group_count }}</td>
          <td>{{ item.website_count }}</td>
          <td>{{ item.total_fee }}</td>
        </tr>
      </table>
    </div>

  </div>
</template>
<script>
import dayjs from 'dayjs';
import { Select, Option, Input, DatePicker } from 'element-ui';
import { report, finance } from '@/api';
import utils from '@/utils/utils';

export default {
  name: 'statisticsAdmission',
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      loading: true,
      searchFormData: {
        org_id: '',
        year: `${new Date().getFullYear()}`,
        term: '',
        specialized_subject_id: '',
        root_specialized_subject_id: '',
        contract_type: '',
        date: [],
        query: ''
      },
      years: [],
      terms: [],
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      contract_types: [],
      contract_statues: [],
      getTableData: [],
      totalTableData: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: [
        dayjs()
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ]
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
    this.getOrg();
  },
  computed: {
    label() {
      return value => {
        if (value) return this.terms.find(item => item.value === value).label;
        return '';
      };
    }
  },
  methods: {
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    changeOrg(row) {
      this.searchFormData.org_id = row.org_id;
      this.getRootSp();
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    async search() {
      this.loading = true;
      let temp = {
        ...this.searchFormData

        // start_date: this.date && this.date.length ? `${this.date[0]} 00:00:00` : -1,
        // end_date: this.date && this.date.length ? `${this.date[1]} 23:59:59` : -1
      };
      if (this.date && this.date.length === 2) {
        temp = {
          ...temp,
          start_date: this.date[0],
          end_date: this.date[1]
        };
      }
      Object.keys(temp).forEach(key => {
        const value = temp[key];
        if (value && value !== -1) temp[key] = value;
        else delete temp[key];
      });
      console.log(temp);
      report.getAdmissionStatistics(temp).then(res => {
        if (res) {
          this.getTableData = res.data.list;
          this.totalTableData = res.data.total;
          console.log(this.getTableData);
        }
        this.loading = false;
      });
    },

    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) delete params[key];
      });
      report
        .exportBackStudyRate({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '招生状况统计');
        });
    }
  }
};
</script>
<style lang='less'>
.statistics-admission {
  .el-select {
    width: 160px;
  }

  .ly-search-comp {
    display: inline-block;
    width: 180px;

    .el-select {
      width: 100%;
    }
  }

  .el-input {
    width: 100%;
    height: 36px;
    line-height: 36px;

    input {
      height: 36px;
      line-height: 36px;
    }
  }

  .el-date-editor {
    height: 36px;
    line-height: 36px;

    input {
      height: 34px;
      line-height: 34px;
    }
  }

  > * {
    margin: 0 10px;
  }
}
</style>
